import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import {
    Accordion, AccordionDetails, AccordionSummary, Box, FormControl,
    InputLabel, MenuItem, Select, TextField, Typography,
} from "@mui/material"
import { Control, Controller } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { IOrder, SetValueFn } from "./types"

export default function ReferenceSection({ control, setValue }: {
    control: Control<IOrder>
    setValue: SetValueFn
}) {
    const { t } = useTranslation()

    return (
        <Accordion defaultExpanded disableGutters variant="outlined" sx={{ mb: 2, "&:before": { display: "none" } }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ px: 2 }}>
                <Typography sx={{ fontWeight: "bold" }}>{t("orders.form.reference")}</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 2, pb: 2 }}>
                <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "repeat(4, 1fr)" }, gap: 2 }}>
                    <Controller control={control} name="reference_name"
                        render={({ field }) => <TextField {...field} label={t("orders.form.refName")} size="small" fullWidth />}
                    />
                    <Controller control={control} name="reference_paper_color"
                        render={({ field }) => (
                            <FormControl size="small" fullWidth>
                                <InputLabel>{t("orders.form.paper")}</InputLabel>
                                <Select {...field} label={t("orders.form.paper")}>
                                    <MenuItem value={0}>{t("orders.form.color.na")}</MenuItem>
                                    <MenuItem value={1}>{t("orders.form.color.white")}</MenuItem>
                                    <MenuItem value={2}>{t("orders.form.color.kraft")}</MenuItem>
                                </Select>
                            </FormControl>
                        )}
                    />
                    <Controller control={control} name="reference_width"
                        render={({ field }) => <TextField {...field} label={t("orders.form.width")} size="small" type="number" fullWidth onChange={e => {
                            field.onChange(e)
                            const w = Number(e.target.value)
                            const extW = (w * 2) + 3
                            setValue("extrusion_width", extW)
                            setValue("extrusion_width_min", extW)
                            setValue("extrusion_width_max", extW + 0.5)
                        }} />}
                    />
                    <Controller control={control} name="reference_height"
                        render={({ field }) => <TextField {...field} label={t("orders.form.height")} size="small" type="number" fullWidth />}
                    />
                    <Controller control={control} name="reference_grammage"
                        render={({ field }) => <TextField {...field} label={t("orders.form.grammage")} size="small" type="number" fullWidth />}
                    />
                    <Controller control={control} name="reference_sides"
                        render={({ field }) => <TextField {...field} label={t("orders.form.sides")} size="small" type="number" fullWidth />}
                    />
                    <Controller control={control} name="reference_bellows"
                        render={({ field }) => <TextField {...field} label={t("orders.form.bellows")} size="small" type="number" fullWidth />}
                    />
                </Box>
            </AccordionDetails>
        </Accordion>
    )
}
